/* eslint-disable require-yield,no-console,no-undef */
import { call, put, takeLatest } from 'redux-saga/effects';
import { rateApi } from '../../../api/fetch';

function* progressE(action) {
    let { data, staticInclude } = action.payload;
    try {
        const rateResponse = yield call(rateApi, data);
        yield put({
            type: 'REMOVE_ALL',
            payload: {
                client_id: parseInt(rateResponse.client_id, 10),
                name: null,
                phone: null,
                email: null,
                address: null
            }
        });
        yield put({ type: 'WS_CLOSE', payload: true });
        yield put({ type: 'START_WS', payload: false });
        yield put({
            type: 'SAGA_FIRST',
            payload: { staticInclude, clientInfo: {}, maxWin: false }
        });
    } catch (e) {
        yield put({ type: 'ERROR', message: e.message });
    }
}

function* SagaRate() {
    yield takeLatest('RATE', progressE);
}


export default SagaRate;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaRate.js